export const environment = {
  production: true,
  configFile: 'assets/config/prod/config-app.json',
};
